import { render } from "./Landing2.vue?vue&type=template&id=749290ee"
import script from "./Landing2.vue?vue&type=script&lang=js"
export * from "./Landing2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__